import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { MFALoginComponent } from './mfa-login.component';
import { lastValueFrom, catchError } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { HandleError } from 'src/app/utils/network-error-handler';
import { HttpClient } from '@angular/common/http';
import { AuthSessionDto, CLU_MOBILE_INTERFACE } from 'src/app/app.models';

@Injectable({
    providedIn: 'root'
})
export class MfaLoginService {
    componentRef: ComponentRef<MFALoginComponent> | null = null;

    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private injector: Injector 
    ) { }

    show(options: { AccessToken: string, CluInterface: CLU_MOBILE_INTERFACE }) {
        return new Promise<string>((resolve, reject) => {
            if (!!this.componentRef) { reject(); return; }
            this.componentRef = this.componentFactoryResolver.resolveComponentFactory(MFALoginComponent).create(this.injector);
            this.componentRef.instance.accessToken = options.AccessToken;
            this.componentRef.instance.cluInterface = options.CluInterface;
            this.appRef.attachView(this.componentRef.hostView);
            const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
            document.body.appendChild(domElem);
            this.componentRef.instance.onResult.subscribe(result => {
                this.hide();
                resolve(result);
            });
        });
    }

    hide() {
        if (!this.componentRef) { return; }
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
        this.componentRef = null;
    }

    doValidateDoubleAuthenticationCode(cluInterface: CLU_MOBILE_INTERFACE, accessToken: string, codeMfa: string) {
        return lastValueFrom(this._httpClient.post<string>(
            cluInterface == CLU_MOBILE_INTERFACE.BACKOFFICE ? 
                this._apiService.endPointsBO.doValidateDoubleAuthenticationCode_BOAdmAuth : 
                this._apiService.endPointsFO.doValidateDoubleAuthenticationCode_FOAuth, 
            { CODE_MFA: codeMfa }, { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'text' as any }
        ).pipe(catchError(error => {
            if (!!error.error) {
                try { error.error = JSON.parse(error.error); } catch {}
            }
            return lastValueFrom(HandleError(error));
        })));
    }
}